
import './three.module.js';

import '../../i18n/translations.js';
import '../../libs/cms/translations.js';

import './classes/PaintingTool.js';
import './GameTools.js';
import './app.js';

import { ObjectClickHandler }  from "./../utils/object-click-handler.js";
import { Oeuvre }              from "./classes/oeuvre.js";
import { Painting }            from "./classes/painting.js";
import { Statue }              from "./classes/statue.js";
import ActStack                from "./classes/ActStack.js";
import Helpers                 from './classes/Helpers.js';
import Player                  from './classes/Player.js';
import { adjustPointToHeight } from './classes/Player.js';

window.ObjectClickHandler = ObjectClickHandler;
window.Oeuvre             = Oeuvre;
window.Painting           = Painting;
window.Statue             = Statue;
window.ActStack           = ActStack;
window.Helpers            = Helpers;
window.Player             = Player;
window.adjustPointToHeight = adjustPointToHeight;

import {
//	saveLocally, Ei käytössä
//	getSaves,
	Arrangement
} from "./Arrangements.js";

//window.saveLocally     = saveLocally; Ei käytössä
//window.getSaves        = getSaves; Ei käytössä
window.Arrangement       = Arrangement;

import "./services/PluginsService.js";

import EntitySelectionService       from "./services/EntitySelectionService.js";
import ObjectClickHandlerService    from "./services/ObjectClickHandlerService.js";
import DragHandlesService           from "./services/DragHandlesService.js";
import { DragHandle }               from "./services/DragHandlesService.js";
import HUDService                   from "./services/HUDService.js";
import WallsHandlerService          from "./services/WallsHandlerService.js";
import { WallService }              from "./services/WallsHandlerService.js";
import Spherical360SetupService     from "./services/Spherical360SetupService.js";
import { Spherical360Setup }        from "./services/Spherical360SetupService.js";
import ContextMenuService           from "./services/ContextMenuService.js";
import UserActionHistoryService     from "./services/UserActionHistoryService.js";
import AdditionalObjectService      from "./services/AdditionalObjectService.js";
import ArrangementService           from './services/ArrangementService.js';
import { GameSceneService }         from './services/game-scene.service.js';
import OeuvresHandlerService        from './services/OeuvresHandlerService.js';
import PreviewModelService          from './services/PreviewModelService.js';
import { PreviewModel }             from './services/PreviewModelService.js';
import CommentHandlersService       from './services/CommentsService.js';
import { CommentsHandler, Comment } from './services/CommentsService.js';
import LODService                   from './services/LODService.js';
import ObjectNamingService          from './services/ObjectNamingService.js';
import ObjectSolverService          from './services/ObjectSolverService.js';

import { ArrangementPanelObjectContainersControlComponent } from './components/arrangement-panel-object-containers-control/arrangement-panel-object-containers-control.component.js';

import { ContextModalBodyAdditionalObjectTextComponent } from './components/context-modals/context-modal-body-additional-object-text.component.js';
import { ContextModalBodyObjectClickHandlerObjectSettingsComponent } from './components/context-modals/context-modal-body-object-click-handler-object-settings.component.js';

import { GameSceneStateComponentController }				from './components/game-scene-view/game-scene-view.controller.js';
import { GameSceneControlsStateComponentController }		from './components/game-scene-controls-view/game-scene-controls-view.controller.js';
import { GameSceneOeuvresPanelStateComponentController }	from './components/game-scene-oeuvres-panel-view/game-scene-oeuvres-panel-view.controller.js';

window.DragHandle        = DragHandle
window.WallService       = WallService;
window.Spherical360Setup = Spherical360Setup;
window.PreviewModel      = PreviewModel;
window.CommentsHandler   = CommentsHandler;
window.Comment           = Comment;

import {
	unsafeFilter,
	objLengthFilter,
	dateToStringFilter,
	contenteditableDirective,
	customOnChangeDirective,
	convertToNumberDirective,
	numberToScaleDirective,
	numberToFixedDirective,
	artestInputUidDirective,
	modalLurkingFooterDirective,
} from './components.js';

import { AjsStateIndicatorComponent } from './features/state-indicator/state-indicator.component.js';
import { StateIndicatorService } from './features/state-indicator/state-indicator.service.js';
import { PlayerHandlerService } from './services/player-handler.service.js';
import { ContextModalBodyHTMLComponent } from './components/context-modals/context-modal-body-html.component.js';

import { DevelopingToolingKit } from './features/developer-tooling-kit/developing-tooling-kit.js';

window.DevelopingToolingKit = DevelopingToolingKit;

angular.module( "gameApp" )

	/* services/* */
	.run([ "objectClickHandlerService", angular.noop ])

//	.service( "", PluginsService )
	.service( "entitySelectionService",    EntitySelectionService )
	.service( "objectClickHandlerService", ObjectClickHandlerService )
	.service( "dragHandlesService",        DragHandlesService )
	.service( "HUDService",                HUDService )
	.service( "wallsHandlerService",       WallsHandlerService )
	.service( "spherical360SetupService",  Spherical360SetupService )
	.service( "contextMenuService",        ContextMenuService )
	.service( "userActionHistoryService",  UserActionHistoryService )
	.service( "additionalObjectService",   AdditionalObjectService )
	.service( "ArrangementService",        ArrangementService )
	.service( "gameSceneService",          GameSceneService )
	.service( "$oeuvresHandler",           OeuvresHandlerService )
	.service( "PreviewModelService",       PreviewModelService )
	.service( "commentHandlersService",    CommentHandlersService )
	.service( "LODService",                LODService )
	.service( "objectNamingService",       ObjectNamingService )
	.service( "objectSolverService",       ObjectSolverService )
	/* / services/* */

	/* components.js */
	.filter(     'unsafe',                   unsafeFilter )
	.filter(     'objLength',                objLengthFilter )
	.filter(     'dateToString',             dateToStringFilter )
	.service(    '$playerHandler',           PlayerHandlerService )
	.directive(  'contenteditable',          contenteditableDirective )
	.directive(  'customOnChange',           customOnChangeDirective )
	.directive(  'convertToNumber',          convertToNumberDirective )
	.directive(  'numberToScale',            numberToScaleDirective )
	.directive(  'numberToFixed',            numberToFixedDirective )
	.directive(  'artestInputUid',           artestInputUidDirective )
	.directive(  'modalLurkingFooter',       modalLurkingFooterDirective )
	/* / components.js */

	.component( 'stateIndicator',           AjsStateIndicatorComponent )
	.service( 'stateIndicatorService',      StateIndicatorService )

	.component( 'arrangementPanelObjectContainersControl', ArrangementPanelObjectContainersControlComponent )

	.component( ContextModalBodyAdditionalObjectTextComponent.name, ContextModalBodyAdditionalObjectTextComponent )
	.component( ContextModalBodyObjectClickHandlerObjectSettingsComponent.name, ContextModalBodyObjectClickHandlerObjectSettingsComponent )
	.component( ContextModalBodyHTMLComponent.name, ContextModalBodyHTMLComponent ) 

	.controller( 'view.game-scene',               GameSceneStateComponentController )
	.controller( 'view.game-scene.controls',      GameSceneControlsStateComponentController )
	.controller( 'view.game-scene.oeuvres-panel', GameSceneOeuvresPanelStateComponentController )
